import * as React from 'react';
import { useState, useEffect } from 'react';

import {
    Value,
    Values,
} from 'one-ui-values';

import {
    PCPModal
} from './model';

import {
    PatientCareProviderCardProps,
} from './props';

import {
    CardLight,
} from 'one-ui-card/src/card-light';

import Col from 'antd/lib/col';
import Row from 'antd/lib/row';

import {
    CardNoData
} from 'one-ui-card';

import Skeleton from 'antd/lib/skeleton';

import {
    checkCardHasError,
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';
import { useCtx } from "one-ui-provider";
import Select from "antd/lib/select";
import Pagination from 'antd/lib/pagination';

const { Option }  =  Select;

/**
 * This function returns all the PCP information
 * @param props has all input parameters to load the Card
 * @returns JSX code for PCP
 */
export const PatientCareProviderCard = <M extends PCPModal>(
    props: PatientCareProviderCardProps<M>
) => {
    const {
        model,
        title,
        skeleton,
    } = props;

    const {
        pcpdata
    } = model;

    const { settings } = useCtx();
    const { uisettings: { dashboardcardconfig } } = settings;

    const {
        pendingCare_skeleton,
    } = skeleton;
    let pcpUI:any = [];
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(1);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    useEffect(() => {
      // Reset the dropdown value and selected department ID when currentPage changes
      setSelectedDepartment(null);
    }, [currentPage]);

    useEffect(() => {
      // Reset the dropdown value and selected department ID 
      setSelectedDepartment(null);
      setSelectedLocation(null);
    }, [pcpdata]);
    
    const handlePageChange = (pageNumber: number) => {
      setCurrentPage(pageNumber);
    };
    
    const handleDepartmentChange = (value: any) => {
      setSelectedDepartment(value);
      setSelectedLocation(null);
    };
    
    const handleLocationChange = (value: any) => {
      setSelectedLocation(value);
    };



    const renderPageData = (currentItems: any) => {
      return currentItems.map((item: any) => (
        <Row key={item.id}> {/* Add a unique key for each rendered row */}
          <Col>
            <Values>
              <Value label="Name" value={item.name} />
            </Values>
          </Col>
          {item.center && (
            <Col>
              <Values>
                <Value label="Type" value={item.center} />
              </Values>
            </Col>
          )}
          <Col>
            <Select
              style={{ width: 200, marginBottom: 16, marginTop: 5 }}
              placeholder="Select Department"
              size="small"
              onChange={handleDepartmentChange}
              value={selectedDepartment} 
            >
            {!selectedDepartment && (
            <Option value={null} disabled>
              Select department
            </Option>
          )}
          {item.department?.map((department: any) => (
            <Option key={department.id} value={department.id}>
              {department.deptname}
            </Option>
          ))}
            </Select>
    
            {selectedDepartment && (
              <Select
                size="small"
                style={{ width: 200 }}
                placeholder="Select location"
                value={ selectedLocation}
                onChange={handleLocationChange}
              >
              {!selectedLocation && (
              <Option value={null} disabled>
              Select Location
              </Option>
             )}
              {item.department
              .find((department: any) => department.id === selectedDepartment)
                ?.location.map((location: any) => (
              <Option key={location.id} value={location.id}>
                  {location.locname}
              </Option>
               ))}
              </Select>
            )}
          </Col>
        </Row>
      ));
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const currentItems = pcpdata.slice(indexOfFirstItem, indexOfLastItem);


    // If Patient Care skeleton is true
    if (pendingCare_skeleton) {
        pcpUI = (<Skeleton active paragraph={{ rows: 1 }} />);
    }

    if(checkCardHasError('PCP') && 
    (pcpdata && (pcpdata).length === 0)){
        pcpUI = 
        <>
            <CardErrorMsg />
        </>
    }

    if (pcpdata?.length > 0) {
      pcpUI = (
        <>
          {renderPageData(currentItems)}
          <Pagination
            current={currentPage}
            total={pcpdata.length}
            size="small"
            pageSize={1}
            style={{ marginLeft: "134px", marginTop: "9px" }}
            onChange={handlePageChange}
          />
        </>
      );
    }
    
       //Chech for No Data
    else if(pcpdata && (pcpdata).length === 0 && !pendingCare_skeleton) {
        pcpUI = (
            <CardNoData />
        )
    }

    // Based on patientCareTeam flag If patientCareTeam flag set as false then Lock Icon Will Show
    if (!dashboardcardconfig?.patientCareTeam){
        pcpUI = 
        <>
            <CardLockIcon />
        </>
    }

    return (
        <CardLight
            title={title}
            body={(
                <div >
                {pcpUI}
                </div>
            )}
        />
    );
};
